// extracted by mini-css-extract-plugin
export default {"button":"Button_button__-d9Cr","primary":"Button_primary__uIz21","secondary":"Button_secondary__5M6Zd"};